<template>
  <div>
    <Title :pages="[{ icon: 'inbox', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :button_name="$t('Crear') + ' ' + modal_title"
        :modal_title="modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{
            descending: true,
            itemsPerPage: 15,
          }"
          @pagination="updatePagination"
          :footer-props="{
            itemsPerPageOptions: [5, 10, 15, 50, -1],
          }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.cuit }}</td>
              <td>{{ props.item.iva_condition.name }}</td>
              <td>{{ props.item.mono_category != null ? props.item.mono_category.category : "-" }}</td>
              <td>
                <v-icon small color="green" v-if="props.item.enabled"> check </v-icon>
                <v-icon small color="red" v-if="!props.item.enabled"> close </v-icon>
              </td>

              <td class="text-center px-0">
                <v-tooltip bottom v-if="props.item.use_afip">
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="black" class="mr-2" @click="testAFIP(props.item)"> sync </v-icon>
                  </template>
                  <span>Test ARCA</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)"> edit </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-1" @click="viewItem(props.item)"> remove_red_eye </v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)"> delete </v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Busqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import Constant from "@/constants/sections";
import { emmiterService } from "@/libs/ws/emmiterService";
import { formatUtils } from "@/libs/utils/formatUtils";
import GenericMixin from "@/mixins/GenericMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import { emit } from "process";

export default {
  components: { Title, Modal, DialogDelete },
  mixins: [GenericMixin, RolMixin],
  data() {
    return {
      formatUtils: formatUtils,
      parent: this,
      service: emmiterService,
      page_title: "Emisores",
      modal_title: "Emisor",
      mainItem: {
        id: "",
        name: "",
        phone: "",
        mail: "",
        cbu: "",
        alias: "",
        cuit: null,
        iva_condition: null,
        ingresos_brutos_nr: "",
        address: "",
        start_activity_date: null,
        afip_key_file: null,
        afip_cert_file: null,
        mono_category: null,
        ptos_venta_facturacion: [],
        ptos_venta_remitos: [],
        impuesto_inscripto: [],
        afip_key_expiring_date: null,
        use_afip: false,
        enable: true,
        use_afip_global_cert: false,

        external_reference: null,
        postal_code: null,
        location: null,
        provincia: null,
      },
      defaultItem: null,
      headers: [
        {
          text: "Nombre",
          align: "left",
          sortable: true,
          value: "name",
        },
        {
          text: "CUIT",
          align: "left",
          sortable: true,
          value: "cuit",
        },
        {
          text: "Condición frente al IVA",
          align: "left",
          sortable: true,
          value: "iva_condition.name",
        },
        {
          text: "Categoria Mono",
          align: "left",
          sortable: true,
          value: "mono_category.category",
        },
        {
          text: "Habilitado",
          align: "left",
          sortable: true,
        },
        { text: "Accion", value: "", align: "center" },
      ],
      list: [],
      dialog_delete: false,
      loading_test_afip: false,
    };
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
    testAFIP(item){
      if(!item.use_afip){
        this.$toast.error("El emisor no utiliza ARCA.");
        return;
      }

      if(this.loading_test_afip){
        this.$toast.info("Ya se esta realizando un Test ARCA. Por favor espere.");
        return;
      }
      this.loading_test_afip = true;

      emmiterService.testAFIP(item.id)
        .then((response) => {
          if (response.success) {
            this.$toast.success("Test ARCA realizado con exito.");
          } else {
            this.$toast.error("Error al realizar el Test ARCA: " + response.message);
          }
        })
        .catch((error) => {
          this.$toast.error("Error al realizar el Test ARCA: " + error.message);
        })
        .finally(() => {
          this.loading_test_afip = false;
        });
    }
  },
};

// TODO agregar un boton de limpiar busqueda.
</script>
